'use client';

import { create } from 'zustand';
import cookies from 'js-cookie';

import en from './backup/fallback-en.json';
import no from './backup/fallback-no.json';

type Language = 'en' | 'no';
type Key = keyof typeof en;
type Translation = typeof en;

type TranslationState = {
  language: Language
  translations: Record<Language, Translation>
  t: <T = unknown, const K extends Key | (string & {}) = Key>(key: K) => (
    unknown extends T
      ? K extends Key
        ? Translation[K]
        : string
      : T
  )
  changeLanguage: (lang: Language) => void
  fetchLanguage: () => Promise<void>
};

export function cookieToFMSLang() {
  const cookieLang = cookies.get('lang');

  if (cookieLang === 'nb') {
    return 'no';
  }

  if (cookieLang === 'en') {
    return 'en';
  }

  return 'no';
}

const useTranslation = create<TranslationState>(
  (set, get) => ({
    language: cookieToFMSLang(),
    translations: {
      en, no,
    },
    t(key) {
      const { language } = get();
      const { translations } = get();

      const translation = translations[language] as Translation;

      if (key in translation) {
        return translation[key as Key];
      }

      return `__?${key}?__` as any;
    },
    changeLanguage(lang) {
      set({ language: lang });
    },
    async fetchLanguage() {
      const { language } = get();

      const version = (
        window.location.href.includes('www.storebrand.no')
          ? 'active'
          : 'pending'
      );

      const url = `https://api.storebrand.no/open/content/texts/navbar?version=${version}&lang=${language}`;

      const result = await fetch(url);

      set({
        translations: {
          ...get().translations,
          [language]: await result.json() as Translation,
        },
      });
    },
  }),
);

export default useTranslation;
